webpackJsonp([89399205538831],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sauces.23087f34.png";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(134);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(409);
	
	var _sauces = __webpack_require__(563);
	
	var _sauces2 = _interopRequireDefault(_sauces);
	
	var _MenuData = __webpack_require__(221);
	
	var _MenuData2 = _interopRequireDefault(_MenuData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import lunchImg from '../../assets/lunch.png'
	
	
	var uid = function uid() {
	  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	
	  var text = '';
	  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
	  for (var i = 0; i < length; i++) {
	    text += possible.charAt(Math.floor(Math.random() * possible.length));
	  }return text;
	};
	
	var Item = function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  function Item() {
	    _classCallCheck(this, Item);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Item.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'mb-3' },
	      _react2.default.createElement(
	        'div',
	        { className: 'd-flex justify-content-between' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-uppercase item-title' },
	          data.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'courier-new price text-nowrap' },
	          data.price,
	          ' \u20AC'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        data.description
	      ),
	      data.description2 && _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        data.description2
	      )
	    );
	  };
	
	  return Item;
	}(_react2.default.Component);
	
	var MenuDrink = function MenuDrink(_ref) {
	  var data = _ref.data,
	      hide = _ref.hide;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)({ hide: hide }) },
	    data.sections.map(function (section) {
	      return _react2.default.createElement(
	        'div',
	        { key: 'section-' + section.sectionTitle, className: 'pr-0 pr-lg-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'text-uppercase item-title' },
	            section.sectionTitle
	          )
	        ),
	        section.items.map(function (item) {
	          return _react2.default.createElement(Item, { data: item, key: 'item-' + uid() });
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          '........................'
	        )
	      );
	    })
	  );
	};
	
	var MenuItem = function (_React$Component2) {
	  _inherits(MenuItem, _React$Component2);
	
	  function MenuItem() {
	    _classCallCheck(this, MenuItem);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  MenuItem.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        hide = _props.hide;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('pr-0 pr-lg-5 item-title', { hide: hide }) },
	      data.items.map(function (item) {
	        return _react2.default.createElement(Item, { data: item, key: 'item-' + uid() });
	      }),
	      data.key === 'springrolls' && _react2.default.createElement('img', { className: 'sauces', src: _sauces2.default, alt: 'sauces pour rouleaux de printemps' })
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	var Menu = function (_React$Component3) {
	  _inherits(Menu, _React$Component3);
	
	  function Menu() {
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _React$Component3.call.apply(_React$Component3, [this].concat(args))), _this3), _this3.state = {
	      navigation: 'starters'
	    }, _this3.navigateTo = function (section) {
	      return _this3.setState({ navigation: section });
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  Menu.prototype.render = function render() {
	    var _this4 = this;
	
	    var navigation = this.state.navigation;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'menu-navigation' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row no-gutters mb-4 section-navigation' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 mb-4 text-center d-flex justify-content-center justify-content-lg-start flex-wrap' },
	          _MenuData2.default.map(function (section) {
	            return _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('section-title', { selected: navigation === section.key }),
	                key: 'section-title-' + section.key,
	                onClick: _this4.navigateTo.bind(_this4, section.key)
	              },
	              section.title
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row no-gutters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'menu col-12 col-lg-5 col-xl-4' },
	          _MenuData2.default.map(function (section) {
	            if (section.key === 'drinks') {
	              return _react2.default.createElement(MenuDrink, {
	                data: section,
	                key: 'section-drinks',
	                hide: navigation !== section.key
	              });
	            }
	
	            return _react2.default.createElement(MenuItem, {
	              data: section,
	              key: 'section-' + section.key,
	              hide: navigation !== section.key
	            });
	          })
	        ),
	        _react2.default.createElement('div', {
	          className: (0, _classnames2.default)('col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-navigation img-right ' + navigation)
	        })
	      )
	    );
	  };
	
	  return Menu;
	}(_react2.default.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  key: 'starters',
	  title: 'Entrées',
	  items: [{
	    title: 'soupe tom yum coco',
	    description: 'Champignons, tomates cerises, ciboule thaï et coriandre fraîche',
	    price: '4,2'
	  }, {
	    title: 'salade de concombre aux 3 sésames',
	    description: 'Sésame blanc, sésame noir, sésame wasabi',
	    price: '4,2'
	  }, {
	    title: 'riz sauté végétarien',
	    description: 'Tofu 5 parfums, champignons, haricots verts, oeuf, gingembre',
	    price: '4,2'
	  }]
	}, {
	  key: 'tapas',
	  title: 'Tapas',
	  items: [{
	    title: 'ribs aux 5 parfums',
	    description: 'Travers de Porc confits et caramélisés au four',
	    price: '8'
	  }, {
	    title: 'mini tartinettes de Banh-mi',
	    description: '(dispo uniquement le soir & le week-end) Tous les ingrédients du fameux sandwich vietnamien en version tartine ! Version classique au porc xá xíu ou végétarienne au choix',
	    price: '5,5'
	  }]
	}, {
	  key: 'springrolls',
	  title: 'Rouleaux',
	  items: [{
	    title: 'crevette',
	    description: 'Crevette, mangue, carottes pickles, cacahuètes, oignons frits',
	    price: '4'
	  }, {
	    title: 'veggie',
	    description: 'Avocat, omelette japonaise, oignons caramélisés déglacés au vinaigre balsamique, oignons frits',
	    price: '4'
	  }, {
	    title: 'tofu',
	    description: 'Tofu grillé à la citronnelle, poivron rouge, shiso, haricot, champignon de paris, cacahuète',
	    price: '4'
	  }, {
	    title: 'saumon fumé',
	    description: 'Saumon fumé d’Atlantique, roquette, oignons frits, fromage frais fouetté, pomme gala, concombre',
	    price: '4'
	  }, {
	    title: 'porc citronnelle',
	    description: 'Poitrine de porc grillé à la citronnelle, carottes pickles, concombre, cacahuètes',
	    price: '4'
	  }, {
	    title: 'saumon teriyaki',
	    description: 'Pavé de saumon mariné au Teriyaki, oignons & gingembres grillés',
	    price: '4'
	  }, {
	    title: 'rouleau du moment',
	    description: "Selon l'humeur du chef 😋",
	    price: '4'
	  }]
	}, {
	  key: 'deserts',
	  title: 'Desserts',
	  items: [{
	    title: 'panna cocotta',
	    description: 'Panna cotta de lait de coco et son coulis de mangue',
	    price: '3,9'
	  }, {
	    title: 'pandan sponge cake',
	    description: 'Gâteau nuageux au parfum d’Asie',
	    price: '4'
	  }, {
	    title: 'madeleines au thé vert matcha(x2)',
	    description: '',
	    price: '3,9'
	  }, {
	    title: 'marbré sapa',
	    description: 'Gâteau marbré au thé vert matcha',
	    price: '4,9'
	  }, {
	    title: 'le roulé de banoi',
	    description: 'Gâteau roulé au sésame noir et crème chantilly de coco',
	    price: '5'
	  }]
	}, {
	  key: 'drinks',
	  title: 'Boissons',
	  sections: [{
	    sectionTitle: 'boissons fraîches',
	    items: [{
	      title: 'charitea maté',
	      description: 'Maté effervescent à l’orange et citron – un plein de caféine !',
	      price: '3,9'
	    }, {
	      title: 'lemonaid fruit de la passion',
	      description: 'Boisson gazeuse rafraichissante au fruit de la passion réhaussée de mangue et de citron vert !',
	      price: '3,9'
	    }]
	  }, {
	    sectionTitle: 'boissons maison',
	    items: [{
	      title: 'Đá chanh',
	      description: 'Citronnade vietnamienne minute',
	      price: '4'
	    }, {
	      title: 'thé glacé maison',
	      description: 'Thé vert du Vietnam, miel & citron vert ou Thé noir Litchi sucre & citron jaune',
	      price: '4,2'
	    }, {
	      title: 'cà phê đá vietnamien',
	      description: 'Café vietnamien glacé',
	      price: '4,5'
	    }, {
	      title: 'cà phê sua đá vietnamien',
	      description: 'Café vietnamien frappé au lait concentré sucré',
	      price: '4,8'
	    }, {
	      title: 'cà phê đá cốt dừa',
	      description: 'Café frappé au lait de coco et lait concentré sucré (Option sans lactose/sans sucre disponible)',
	      price: '5'
	    }]
	  }, {
	    sectionTitle: 'boissons chaudes',
	    items: [{
	      title: 'cà phê vietnamien',
	      description: 'Café Robusta importé du Vietnam, aux notes « chocolatées », filtré à la vietnamienne',
	      price: '3,5'
	    }, {
	      title: 'cà phê sua vietnamien',
	      description: 'Café du Vietnam au lait concentré sucré, comme au pays !',
	      price: '4'
	    }, {
	      title: 'thé Vert du Vietnam',
	      description: '',
	      price: '4'
	    }, {
	      title: 'thé noir de Chine litchi',
	      description: '',
	      price: '4'
	    }, {
	      title: 'thé au jasmin',
	      description: '',
	      price: '4'
	    }, {
	      title: 'infusion detox comme à la maison',
	      description: 'Menthe, Miel, Gingembre & Citron vert',
	      price: '4,5'
	    }]
	  }, {
	    sectionTitle: 'alcools',
	    items: [{
	      title: 'cocktail saigon royal iced tea',
	      description: 'Gin 4cl, Thé Glacé au Litchi & Citron, ultra rafraichissant !',
	      price: '8,5'
	    }, {
	      title: 'bières',
	      description: '- Hanoi beer, pale ale 5,1°, bouteille 33cl',
	      description2: '- Saigon beer, pale ale 4,9° , bouteille 33cl',
	      price: '4,5'
	    }, {
	      title: 'Carte des vins',
	      description: 'verre de vin 12,5cl',
	      price: '4,5'
	    }, {
	      title: 'bouteille de vin',
	      description: '-« Rendez-vous », AOP Côte du Rhône, BIO 2023, Maison Le Jeune, 60% Grenache, 30% Carignan, 10% Cinsault',
	      description2: '-« Lou de Mer », IGP Pays d’OC, BIO 2021, Maison Le Jeune, 100% Chardonnay',
	      price: '25'
	    }]
	  }]
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Menu = __webpack_require__(218);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Layout = __webpack_require__(23);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuPage = function MenuPage(_ref) {
	  var locale = _ref.pathContext.locale;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { locale: locale },
	    _react2.default.createElement(_Menu2.default, null)
	  );
	};
	
	exports.default = MenuPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-menu-js-b06e9df7e1f26860954f.js